import { AuthService, LoginMethods } from '@pw-tech/web-sdk';

export const webSDK =
  typeof window !== 'undefined'
    ? AuthService.getInstance({
        organizationId: process.env.NEXT_PUBLIC_ORG_ID || '',
        apiBaseUrl: process.env.NEXT_PUBLIC_BASE_API_URL || '',
        loginMethods: [LoginMethods.OTP, LoginMethods.PASSWORD],
        localStorageFallback: true,
        clientId: 'system-admin',
        clientSecret: process.env.NEXT_PUBLIC_CLIENT_SECRET || '',
        contextIdentifier: 'TOKEN_CONTEXT',
        loginPageUrl: '/',
        debugMode: false,
      })
    : null;
